type GridBreakpoint = {
  breakpoint: number;
  columns: number;
};

const defaultBreakpoints: GridBreakpoint[] = [
  { breakpoint: 640, columns: 1 },
  { breakpoint: 768, columns: 2 },
  { breakpoint: 1024, columns: 3 },
  { breakpoint: Infinity, columns: 4 },
];

export const getGridColumns = (
  containerWidth: number,
  breakpoints: GridBreakpoint[] = defaultBreakpoints
) => {
  const { columns } = breakpoints.find(
    (bp) => containerWidth < bp.breakpoint
  ) || breakpoints[breakpoints.length - 1];

  return `grid-cols-${columns}`;
};

export const getGridStyle = (containerWidth: number, breakpoints: GridBreakpoint[] = defaultBreakpoints) => {
  const { columns } = breakpoints.find(
    (bp) => containerWidth < bp.breakpoint
  ) || breakpoints[breakpoints.length - 1];

  return {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    gap: '1rem',
  };
};
